/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GatewayNumberStatus {
    SOFT_DELETED = 'SoftDeleted',
    PUBLIC = 'Public',
    PRIVATE = 'Private',
    SYSTEM = 'System',
}
